// =============================================================================
// Teclado numérico táctil — para POS sin teclado físico (tablet/touchscreen).
// Soporta enteros y fracciones (productos a granel). Botones grandes (≥64px) y
// alta legibilidad. Mobile-first: ocupa todo el modal en pantallas chicas.
// =============================================================================
import { useState } from "react";

export function NumericKeypad({
  title, initial = "1", allowFraction = true, max,
  onAccept, onCancel,
}: {
  title: string;
  initial?: string;
  allowFraction?: boolean;
  max?: number;
  onAccept: (n: number) => void;
  onCancel: () => void;
}) {
  const [v, setV] = useState(initial);
  const push = (k: string) => {
    setV((s) => {
      if (k === "⌫") return s.length <= 1 ? "0" : s.slice(0, -1);
      if (k === "C") return "0";
      if (k === "." ) return allowFraction && !s.includes(".") ? s + "." : s;
      const next = s === "0" ? k : s + k;
      const n = parseFloat(next);
      if (max != null && n > max) return s;
      return next;
    });
  };
  const num = parseFloat(v) || 0;
  const overMax = max != null && num > max;

  const keys: string[] = ["7","8","9","4","5","6","1","2","3", allowFraction ? "." : "0", "0", "⌫"];

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 sm:items-center" onClick={onCancel}>
      <div onClick={(e) => e.stopPropagation()} className="w-full max-w-sm rounded-t-2xl bg-white p-5 shadow-2xl sm:rounded-2xl">
        <div className="mb-3 text-center">
          <div className="text-sm text-grafito-400">{title}</div>
          <div className="text-4xl font-extrabold tabular-nums">{v}</div>
          {max != null && <div className="text-xs text-grafito-400">máx {max}</div>}
        </div>
        <div className="grid grid-cols-3 gap-2">
          {keys.map((k) => (
            <button key={k} onClick={() => push(k)} type="button"
              className="h-16 rounded-xl bg-grafito-100 text-2xl font-bold text-grafito-700 active:bg-grafito-200">
              {k}
            </button>
          ))}
        </div>
        <div className="mt-3 grid grid-cols-2 gap-2">
          <button type="button" onClick={onCancel} className="h-14 rounded-xl bg-grafito-100 text-base font-semibold text-grafito-700">Cancelar</button>
          <button type="button" disabled={overMax || num <= 0}
            onClick={() => onAccept(num)}
            className="h-14 rounded-xl bg-brand text-base font-semibold text-white disabled:opacity-40">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}
